
import { Component, Vue } from 'vue-property-decorator'
import Error from "@/components/Error.vue"

@Component({
  components: {
    Error
  }
})
export default class UserManagement extends Vue {
  private loading = false
  public passwordShow = false
  public confirmPasswordShow = false
  private mode: string | null = null
  private oobCode: string | null = null
  public valid = false
  public password = ''
  public confirmPassword = ''
  public passwordRules = [
    (v: any) => !!v || this.$t('global.required'),
    (v: any) => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) || this.$t('account.passwordValidationRule')
  ]

  passwordConfirmationRule () {
    return this.password === this.confirmPassword || this.$t('account.passwordConfirmation')
  }

  get error () {
    const authenticationError = this.$store.getters["account/authenticationError"]
    const globalError = this.$store.getters["error/error"]
    if (authenticationError || globalError) {
      this.loading = false
    }
    return authenticationError
  }

  created () {
    if (this.$route.query && this.$route.query.mode) {
      switch (this.$route.query.mode) {
        case "verifyEmail":
          this.loading = true
          this.mode = 'verifyMail'
          if (this.$route.query.oobCode && this.$route.query.apiKey === process.env.VUE_APP_FIREBASE_API_KEY) {
            this.$store.dispatch('account/handleVerifyEmail', this.$route.query.oobCode)
          }
          break
        case 'resetPassword':
          this.mode = 'resetPassword'
          if (this.$route.query.oobCode && this.$route.query.apiKey === process.env.VUE_APP_FIREBASE_API_KEY) {
            this.oobCode = this.$route.query.oobCode as string
          }
          break
        case 'recoverEmail':
          this.loading = true
          this.mode = 'recoverEmail'
          if (this.$route.query.oobCode && this.$route.query.apiKey === process.env.VUE_APP_FIREBASE_API_KEY) {
            this.$store.dispatch('account/handleRecoverEmail', this.$route.query.oobCode)
          }
          break
        default:
          this.$store.dispatch("error/setError", "Something went wrong")
      }
    }
  }

  public resendAccountVerificationMail () {
    this.$store.dispatch("account/resendMail")
  }

  private resetPassword () {
    this.$store.dispatch('account/resetPassword', { oobCode: this.oobCode, newPassword: this.password })
  }

  public goToRegister () {
    this.$store.commit('account/setAuthenticationError', null)
    this.$router.push({ name: 'register' })
  }
}
